import axios from "axios";

class IBGEService {
  IBGE_API = axios.create({
    baseURL: "https://servicodados.ibge.gov.br/api/v1/localidades/",
  });

  async getPaises(): Promise<any> {
    try {
      const res = await this.IBGE_API.get(`paises`, {
        params: {
          orderBy: "nome",
        },
      });
      const data = res.data?.map((item: any) => item.nome);
      return data;
    } catch (error) {
      console.error(error);
    }
  }

  async getUFs(): Promise<{ sigla: string; nome: string }[] | undefined> {
    try {
      const res = await this.IBGE_API.get(`estados`, {
        params: {
          orderBy: "nome",
        },
      });
      const data = res.data?.map((item: any) => ({
        sigla: item.sigla,
        nome: item.nome,
      }));

      //uf para fora do país
      data.push({ sigla: "EX", nome: "Exterior" });

      return data;
    } catch (error) {
      console.error(error);
    }
  }

  async getMunicipiosByUF(uf: string): Promise<any> {
    try {
      const res = await this.IBGE_API.get(`estados/${uf}/municipios`);

      const data = res.data?.map((item: any) => ({
        ibge: item.id,
        nome: item.nome,
      }));
      return data;
    } catch (error) {
      console.error(error);
    }
  }
}

export default new IBGEService();